module.exports = "zoom-out"